export const testSource = {
  employersAssessment: 'Employers Assessment',
  belongEducation: 'Belong Education',
};
